import React from "react";

import { Props } from "./types";
import styles from "./styles.scss";
import classNames from "classnames";

function ToggleViewButton({ areSortedByGroups, setAreSortedByGroup }: Props) {
  return (
    <div
      className={classNames(styles.toggleViewButton, {
        [styles.active]: areSortedByGroups,
      })}
      onClick={setAreSortedByGroup}
    >
      <div className={styles.toggle} />
    </div>
  );
}

export { ToggleViewButton };
